// First part: Add this to your product page template
document.addEventListener("DOMContentLoaded", function() {
    // Store product data in localStorage when product page loads
    const storeProductData = () => {
        const productTitle = document.querySelector("h1.product__title")?.textContent.trim();
        const specSheetUrl = document.querySelector("[data-spec-sheet-url]")?.getAttribute("data-spec-sheet-url");
        
        if (productTitle && specSheetUrl) {
            localStorage.setItem('currentProductTitle', productTitle);
            localStorage.setItem('currentSpecSheetUrl', specSheetUrl);
            console.log("Stored product data:", { productTitle, specSheetUrl });
        }
    };

    storeProductData();
});

// Second part: This goes in your spec-sheet.js file
document.addEventListener("DOMContentLoaded", function() {
    // Get elements
    const form = document.querySelector(".spec-sheet-form");
    const emailInput = document.querySelector(".spec-sheet-email");
    const requestButton = document.querySelector(".spec-sheet-button");
    const successMessage = document.querySelector(".spec-sheet-success");
    const productNameElements = document.querySelectorAll("#product-name");
    
    // Get product data from localStorage
    const productTitle = localStorage.getItem('currentProductTitle') || "This Product";
    const fileUrl = localStorage.getItem('currentSpecSheetUrl');
    
    console.log("Retrieved from localStorage:", { productTitle, fileUrl });

    // Update all product name instances
    productNameElements.forEach(element => {
        element.textContent = productTitle;
    });

    function downloadFile(url) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    if (form && emailInput && requestButton && successMessage) {
        form.addEventListener("submit", function(event) {
            event.preventDefault();
            
            const email = emailInput.value;
            const formattedProductName = `${productTitle} - Requested Spec Sheet`;

            // Validate email
            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                alert("Please enter a valid email address");
                return;
            }

            // Validate file URL
            if (!fileUrl) {
                alert("Sorry, no spec sheet available for this product.");
                return;
            }

            // Disable button and show loading state
            requestButton.disabled = true;
            requestButton.textContent = "Please Wait...";

            // Send webhook
            fetch("https://shopify-spec-sheet-api-571453632293.europe-west1.run.app/spec-sheet", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    email,
                    productName: formattedProductName
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then(() => {
                // Show success message
                form.style.display = "none";
                successMessage.style.display = "block";

                // Set up manual download link
                const manualDownloadLink = document.getElementById('manual-download');
                if (manualDownloadLink) {
                    manualDownloadLink.href = fileUrl;
                }

                // Trigger automatic download
                console.log("Downloading file:", fileUrl);
                setTimeout(() => {
                    downloadFile(fileUrl);
                }, 1000);
            })
            .catch(error => {
                console.error("Error:", error);
                alert("There was an error processing your request. Please try again.");
            })
            .finally(() => {
                requestButton.disabled = false;
                requestButton.textContent = "Download Spec Sheet";
            });
        });
    }
});